export class HhgBookShipAccessorials {
        public bookAccessorialsId: number;
        public hhGAccessorialsId: number;
        public shipmentsId: number;
        public usageType: string = null;
        public sitNumberOfDays: string = null;
        public requestor: string = 'Shipper';
        public shipperRequest: string = '';
        public tspRequest: string = null;
        public requestedTotalVal: number = null;
        public accessorialCost: number = null;
}
